import React from "react";
import "./ScoreCard3.css";

function ScoreCard3() {
  return (
    <div className="score_card_3">
      <div className="score_card_3_col">
        <p className="score_card_3_col_1st_child">Over : 8</p>
        <p className="score_card_3_col_2nd_child">7 C - 49/6</p>
      </div>
      <div className="score_card_3_col">
        <p className="score_card_3_col_1st_child">This Over : 1</p>
        <p className="score_card_3_col_2nd_child">0, 0, 0, 0, W, 1</p>
      </div>
      <div className="score_card_3_col">
        <p className="score_card_3_col_1st_child">ALI : 10 (5)</p>
        <p className="score_card_3_col_2nd_child">Amjad : 0 (4)</p>
      </div>
      <div className="score_card_3_col ">
        <p className="score_card_3_col_1st_child">Abdullah : 4-0-96-1 </p>
      </div>
    </div>
  );
}

export default ScoreCard3;
